// extracted by mini-css-extract-plugin
module.exports =  {"amenities-list":"_32bbee5fda--amenities-list--HOcVY","amenity-item":"_32bbee5fda--amenity-item--AMH4D"};